// extracted by mini-css-extract-plugin
export default {"gradient-bg5":"eventEdit__gradient-bg5__g6gkg","clubName":"eventEdit__clubName__eOyv1","section":"eventEdit__section__XXAEN"};